<template>
  <div class="errorOpen">
    <NavHeaderBar title="提示" rightArrow />
    <Default
      :imgurl="require('@/assets/img/open.png')"
      text="温馨提示：
您已在收看一个课程,不允许同时收看多个课程,请您规范学习!"
      :errorWork="true"
    >
      <button class="open-btn" @click="goHome">返回首页</button></Default
    >
  </div>
</template>

<script>
import { routerReplace } from "@/config/locationRouter";
export default {
  name: "ErrorOpen",
  methods: {
    goHome() {
      routerReplace({ path: "/" });
    }
  }
};
</script>

<style lang="scss">
.errorOpen {
  overflow: hidden;
  .van-empty__description {
    margin-top: 0;
    text-align: center;
    color: #333333;
  }
  .default {
    .custom-image {
      .van-empty__image {
        width: 328px;
        height: 222px;
      }
      .van-empty__bottom {
        margin-top: 0.64rem;
      }
    }
  }

  .open-btn {
    width: 75px;
    height: 22px;
    background: linear-gradient(180deg, #85b8f9 0%, #2e89f8 100%);
    border-radius: 12.5px;
    border: none;
    font-size: 12px;
    color: #fff;
  }
}
</style>
